import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceStartDiscussionNotificationState = createStateReducer(
  initialState,
  {
    [events.startDiscussionSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "startDiscussion",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.startDiscussionFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "startDiscussion",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceStartDiscussionNotificationState };
